import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { label, className, id, ...rest },
  ref,
) {
  const generatedId = id ?? `checkbox-${Math.random().toString(36).slice(2)}`;
  return (
    <label htmlFor={generatedId} className={cn('inline-flex items-center gap-2 text-sm', className)}>
      <input
        ref={ref}
        id={generatedId}
        type="checkbox"
        className={cn(
          'h-4 w-4 rounded border-brand-gray-light text-brand-red',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-offset-1',
        )}
        {...rest}
      />
      {label && <span className="select-none text-brand-charcoal">{label}</span>}
    </label>
  );
});
